import * as THREE from "three";
import GameConfig from "../config";
import meshCloner from "../utils/meshCloner";

export default class Obstacle {
    constructor({scene, blueprint, length = 2, position = new THREE.Vector3()}) {
        this.scene = scene;
        this.blueprint = blueprint;
        this.boundingBox = this.createBoundingBox(length);
        this.scene.add(this.boundingBox);

        this.mesh = meshCloner(this.blueprint);

        if(length === 1){
            this.mesh.scale.set(1.5,length * 2.5,1.5);
            //this.mesh.rotateX(-Math.PI / 2);
            //this.mesh.rotateY(Math.PI);
            this.mesh.rotateZ(-Math.PI / 2);
            this.meshOffsetX = 0;
        } else if(length === 2){
            this.mesh.rotateY(-Math.PI / 2);
            this.mesh.rotateZ(-Math.PI / 2);
            this.meshOffsetX = length * 1;
            this.mesh.scale.multiplyScalar(0.6);
        } else if(length === 3){
            this.mesh.rotateY(-Math.PI / 2);
            this.mesh.rotateZ(-Math.PI / 2);
            this.meshOffsetX = length * 1;
        }

        this.scene.add(this.mesh);
        this.moveTo(position);
    }

    createBoundingBox(length){
        const dim = 1
        const geometry = new THREE.BoxGeometry( dim * 2 * length, dim, dim * GameConfig.GENERAL.OBSTACLE_DEPTH);
        const material = new THREE.MeshStandardMaterial( {color: 0xff0000} );

        const bb = new THREE.Mesh( geometry, material );

        bb.geometry.computeBoundingBox();
        bb.updateMatrixWorld(true);

        bb.visible = false;

        if(GameConfig.DEBUG.ON && GameConfig.DEBUG.PHYSICS){
            bb.visible = true;
        }

        return bb;
    }

    moveTo(position){
        this.boundingBox.position.copy(position);
        this.mesh.position.copy(position);
        this.mesh.position.x += this.meshOffsetX;
        this.mesh.position.y += 0.3;
    }

    destroy(){
        this.mesh.geometry.dispose();
        this.scene.remove(this.mesh);

        this.boundingBox.geometry.dispose();
        this.scene.remove(this.boundingBox);
    }
}